import { z } from "zod";

/**
 * Shape of `user.settings` as the backend stores and returns it (snake_case).
 * The API types it as an untyped dict, so codegen can't produce this schema.
 */
export const storedSettingsSchema = z
  .object({
    default_model_id: z.string().nullish(),
    custom_instructions: z.string().nullish(),
    response_tone: z.string().nullish(),
    response_length: z.string().nullish(),
    show_context_info: z.boolean().nullish(),
  })
  .partial();

export type StoredSettings = z.infer<typeof storedSettingsSchema>;

/** The stored settings, or {} when they don't match the expected shape. */
export function parseStoredSettings(settings: Record<string, unknown> | null | undefined): StoredSettings {
  const stored = storedSettingsSchema.safeParse(settings ?? {});
  return stored.success ? stored.data : {};
}

export function storedDefaultModelId(settings: Record<string, unknown> | null | undefined): string | null {
  return parseStoredSettings(settings).default_model_id || null;
}

/** The power-user "Show context usage" toggle (AI Preferences); off unless set. */
export function storedShowContextInfo(settings: Record<string, unknown> | null | undefined): boolean {
  return parseStoredSettings(settings).show_context_info === true;
}
